import { GridExportMenuItemProps } from '@mui/x-data-grid-premium';

interface ExportMenuItemProps
  extends GridExportMenuItemProps<Record<string, never>> {
  type: string;
  onExport: (type: string) => void;
  id?: string;
  'data-testid'?: string;
}

const ExportMenuItem = (props: ExportMenuItemProps) => {
  const titleMap: Record<string, string> = {
    csv: 'Export as CSV',
    xlsx: 'Export as Excel',
  };

  return (
    <button
      id={props.id}
      data-testid={props['data-testid']}
      type="button"
      role="menuitem"
      className="w-full text-base font-medium px-4 py-2 text-center hover:bg-neutral-100 transition-colors cursor-pointer"
      onClick={async () => {
        props.hideMenu?.();
        await props.onExport(props.type);
      }}
    >
      <span>{titleMap[props.type]}</span>
    </button>
  );
};

export default ExportMenuItem;
